import {getAction, postAction} from '@/api/manage'

const api = {
    pageList: '/online/mallDecorateV2/page/list',
    pageDetail: '/online/mallDecorateV2/page/detail',
    pageInit: '/online/mallDecorateV2/page/init',
    saveDraft: '/online/mallDecorateV2/page/saveDraft',
    customPageAdd: '/online/mallDecorateV2/page/custom/add',
    customPageRename: '/online/mallDecorateV2/page/custom/rename',
    customPageDelete: '/online/mallDecorateV2/page/custom/delete',
    copyFromStore: '/online/mallDecorateV2/page/copyFromStore',
    publishAll: '/online/mallDecorateV2/page/publishAll',
    applyAll: '/online/mallDecorateV2/template/applyAll',
    templateList: '/online/mallDecorateV2/template/list',
    templatePreview: '/online/mallDecorateV2/template/preview',
    themeList: '/online/mallDecorateV2/theme/list',
    enableV2: '/online/mallDecorateV2/store/enableV2',
    goodsSelector: '/online/mallDecorateV2/selector/goods',
    categorySelector: '/online/mallDecorateV2/selector/category',
    copySourceStoreSelector: '/online/mallDecorateV2/selector/copySourceStore',
    couponSelector: '/online/pageTemplate/listCoupon',
    imageDirList: '/online/pageImageDir/list',
    imageDirAdd: '/online/pageImageDir/add',
    imageList: '/online/pageImage/list',
    imageUpload: window._CONFIG['domianURL'] + '/sys/upload/pageImageUpload'
}

export function initMallDecorateV2(storeShopId) {
    return postAction(`${api.pageInit}?storeShopId=${storeShopId}`, {})
}

export function listMallPageV2(storeShopId) {
    return getAction(api.pageList, {storeShopId})
}

export function getMallPageV2(storeShopId, pageType) {
    return getAction(api.pageDetail, {storeShopId, pageType})
}

export function saveMallPageV2Draft(data) {
    return postAction(api.saveDraft, data)
}

export function addMallCustomPageV2(data) {
    return postAction(api.customPageAdd, data)
}

export function renameMallCustomPageV2(data) {
    return postAction(api.customPageRename, data)
}

export function deleteMallCustomPageV2(data) {
    return postAction(api.customPageDelete, data)
}

export function copyMallDecorateV2FromStore(data) {
    return postAction(api.copyFromStore, data)
}

export function publishMallPageV2(storeShopId) {
    return postAction(`${api.publishAll}?storeShopId=${storeShopId}`, {})
}

export function applyMallTemplateV2(data) {
    return postAction(api.applyAll, data)
}

export function listMallTemplateV2() {
    return getAction(api.templateList)
}

export function previewMallTemplateV2(params) {
    return getAction(api.templatePreview, params)
}

export function listMallThemeV2() {
    return getAction(api.themeList)
}

export function enableMallDecorateV2(data) {
    return postAction(api.enableV2, data)
}

export function selectMallDecorateGoods(params) {
    return getAction(api.goodsSelector, params)
}

export function selectMallDecorateCategory() {
    return getAction(api.categorySelector)
}

export function selectMallDecorateCoupon(params) {
    return getAction(api.couponSelector, params)
}

export function selectMallDecorateCopySourceStore(params) {
    return getAction(api.copySourceStoreSelector, params)
}

export function listMallDecorateImageDir() {
    return getAction(api.imageDirList, {pageSize: 200, pageNo: 1})
}

export function addMallDecorateImageDir(dirName) {
    return postAction(api.imageDirAdd, {dirName})
}

export function listMallDecorateImage(params) {
    return getAction(api.imageList, params)
}

export function getMallDecorateImageUploadUrl(dirId) {
    return `${api.imageUpload}?dirId=${dirId || ''}`
}
